import { useDateTime } from "../../../../../localization/useDateTime"
import { Grid, Typography, Stack } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { tailwindPalette } from "../../../../../theme/tailwindPalette"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { SupportSMS } from "../smsTypes"

const useStyles = makeStyles()(() => ({
    textGray: {
        color: tailwindPalette.gray[500],
    },
}))

export function DetailedPanel({ data }: { data: SupportSMS }) {
    const { id, status, sentTime, history, sender, receiver, text } = data

    const { classes } = useStyles()
    const dateTimeFactory = useDateTime()

    return (
        <Stack direction="column" spacing="1rem">
            <Stack direction="column" spacing=".3rem">
                <Grid container>
                    <Grid item xs={1.5}>
                        <LocalizedStrict id="support-messages-sms-details-id-label">
                            <Typography className={classes.textGray}>id:</Typography>
                        </LocalizedStrict>
                    </Grid>
                    <Grid item xs="auto">
                        <Typography>{id}</Typography>
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item xs={1.5}>
                        <LocalizedStrict id="support-messages-sms-details-status-label">
                            <Typography className={classes.textGray}>Status:</Typography>
                        </LocalizedStrict>
                    </Grid>
                    <Grid item xs="auto">
                        <Typography>{status.text}</Typography>
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item xs={1.5}>
                        <LocalizedStrict id="support-messages-sms-details-created-label">
                            <Typography className={classes.textGray}>Created:</Typography>
                        </LocalizedStrict>
                    </Grid>
                    <Grid item xs="auto">
                        <Typography>
                            {dateTimeFactory.formatDateTime(dateTimeFactory.fromApi(history.created))}
                        </Typography>
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item xs={1.5}>
                        <LocalizedStrict id="support-messages-sms-details-sent-time-label">
                            <Typography className={classes.textGray}>Sent time:</Typography>
                        </LocalizedStrict>
                    </Grid>
                    <Grid item xs="auto">
                        <Typography>{dateTimeFactory.formatDateTime(dateTimeFactory.fromApi(sentTime))}</Typography>
                    </Grid>
                </Grid>
                {status?.errorDetails && (
                    <Grid container>
                        <Grid item xs={1.5}>
                            <LocalizedStrict id="support-messages-sms-details-error-message-label">
                                <Typography className={classes.textGray}>Error message:</Typography>
                            </LocalizedStrict>
                        </Grid>
                        <Grid item xs="auto">
                            <Typography>{status.errorDetails.message}</Typography>
                        </Grid>
                    </Grid>
                )}
            </Stack>

            <Stack direction="column" spacing=".3rem">
                <Grid container>
                    <Grid item xs={1.5}>
                        <LocalizedStrict id="support-messages-sms-details-from-label">
                            <Typography className={classes.textGray}>From:</Typography>
                        </LocalizedStrict>
                    </Grid>
                    <Grid item xs="auto">
                        <Typography>{sender}</Typography>
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item xs={1.5}>
                        <LocalizedStrict id="support-messages-sms-details-to-label">
                            <Typography className={classes.textGray}>To:</Typography>
                        </LocalizedStrict>
                    </Grid>
                    <Grid item xs="auto">
                        <Typography>{receiver.phoneNumber}</Typography>
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item xs={1.5}>
                        <LocalizedStrict id="support-messages-sms-details-text-message-label">
                            <Typography className={classes.textGray}>Text message:</Typography>
                        </LocalizedStrict>
                    </Grid>
                    <Grid item xs="auto">
                        <Typography>{text}</Typography>
                    </Grid>
                </Grid>
            </Stack>
        </Stack>
    )
}
